import React from 'react'
import { Close } from '@radix-ui/react-dialog'
import { useTheme } from 'react-jss'
import { Close as CloseIcon, IkonPromptsucces } from '../../../assets/icons'
import { colors } from '../../../theme/palette'
import { useStyles } from './Dialog'

type CloseProps = {
    handleClose?: () => void
}

const CloseButton = ({ handleClose }: CloseProps): JSX.Element => {
    const iconBGColor = colors.blue300
    const iconBorder = colors.white
    const theme = useTheme<Jss.Theme>()
    const classes = useStyles({
        ...{ iconBGColor, iconBorder },
        theme,
    })
    return (
        <Close asChild>
            <button
                className={classes.button}
                type="button"
                style={{
                    padding: '.5rem',
                    margin: '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                }}
                onClick={() => {
                    handleClose?.()
                }}
            >
                <CloseIcon width="32px" color={colors.green} />
            </button>
        </Close>
    )
}

export default CloseButton
